import React, { useEffect, useState } from "react";
import TippyIcon from "../../../revampComponents/Atom/TippyIcon";
import { cutString } from "../../../services/util";
import SearchBar from "../../../revampComponents/Atom/SearchBar";
import BackendPaginatedDataTable from "../../../revampComponents/Atom/BackendPaginatedDataTable";
import { analyticsResponse, eventId, EXHIBITOR_TASK_STATUS, EXHIBITOR_TASK_TYPES, filterTiles, getEventDateNTime, getISTDateNTimeWTimeZone, getStatusClass, getStatusClassName, getTaskStatusText, priorityBasedIcons, style } from "./TaskManagementConstant";
import { getAllTasks, getTaskAnalytics } from "../../../revampCRUD/taskManagement.crud";
import { Link } from "react-router-dom";
import LoadingSpinner from "../../../revampComponents/Atom/Loading";
import refreshBtn from '../../../assets/refresh-btn.svg'
import backbtn from '../../../assets/backbtn.svg'
import TaskSidebarModal from "../../../revampComponents/TaskSidebarComponent/TaskSidebarModal";
import { useParams, useHistory } from "react-router-dom";
import customToast from "../../../components/common/basic/Toast";
import KonfhubContainer from "../../../revampComponents/Atom/Container";
import TaskAnalyticsFilter from "./TaskAnalyticsFilter";
import SelectedFiltersDisplay from "./SelectedFiltersDisplay";
import { dashboardColors, theme } from "../../../themes/Theme";
import { getISTDateNTime } from "../../../Utils/helpers";

const TaskAnalytics = (
  { eventTimezone }
) => {
  const [attendees, setAttendees] = useState([]);
  const [filteredAttendees, setFilteredAttendees] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [search, setSearch] = useState("");
  const [exhibitorData, setExhibitorData] = useState([]);
  const [filteredAnalyticsData, setFilteredAnalyticsData] = useState([]);
  const [totalCount, setTotalCount] = useState(null);
  const [filterParams, setFilterParams] = useState("");
  const [onProgress, setOnProgress] = useState(false);
  const [exhibitors, setExhibitors] = useState([])
  const [limit, setLimit] = useState(50);
  const [offset, setOffset] = useState(0);
  const [newPerPage, setNewPerPage] = useState(50);
  const [analyticsResponse, setAnalyticsResponse] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const { eventId, taskId } = useParams();
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [displaySelectedFilters, setDisplaySelectedFilters] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [filterDataConfig, setFilteredDataConfig] = useState([]);
  const [statusDataName, setStatusDataName] = useState("");
  const [data, setData] = useState([])
  const [isRemoveFilterClicked, setIsRemoveFilterClicked] = useState(false);

  const [particularTaskDetails, setParticularTaskDetails] = useState({
    taskType: "",
    taskId: "",
    due_date: "",
    reminder_date: "",
    title: "",
    description: "",
    taskColumnMapping: "",
  });
  const fetchFilteredAnalyticsData = async (filters) => {
    setOnProgress(true);
    try {
      const response = await getTaskAnalytics(
        particularTaskDetails.taskId,
        limit,
        offset,
        search,
        filters.status,
      );
      setData(response.data.exhibitors);
      setTotalCount(response.data.total_count);
    } catch (error) {
      console.error("Error fetching filtered analytics:", error);
    } finally {
      setOnProgress(false);
    }
  };
  useEffect(() => {
    fetchFilteredAnalyticsData(filterParams);
  }, [selectedFilters]);

  useEffect(() => {
    const fetchTaskAnalytics = async () => {
      try {
        setLoading(true);
        const response = await getAllTasks();
        const tasks = response.data?.tasks || [];
        const task = tasks.find((t) => t.task_id === taskId);

        if (task) {
          setParticularTaskDetails({
            taskType: task.task_type,
            taskId: task.task_id,
            due_date: task.due_date,
            reminder_date: task.reminder_date,
            title: task.title,
            description: task.description,
            taskColumnMapping: task.task_column_mapping,
          });
        } else {
          customToast.error("Task not found!");
          history.push(`/e/${eventId}/exhibitor-portal/task-management`);
        }
      } catch (error) {
        customToast.error("Error fetching task analytics");
      } finally {
        setLoading(false);
      }
    };

    if (taskId) {
      fetchTaskAnalytics();
    }
  }, [taskId]);

  const setFilterFunction = async (value) => {
    if (value) {
      const temp = attendees.filter(val => val.exhibitor_name.toLowerCase().includes(value.toLowerCase()));
      setFilteredAnalyticsData(temp);
    } else {
      setFilteredAnalyticsData(attendees);
    }
    setSearch(value);
  };
  const getStatusValue = (status) => {
    const statusUpperCase = status.toUpperCase();
    return EXHIBITOR_TASK_STATUS[statusUpperCase];
  };
  const handleFilterTile = async (getStatusValue) => {
    const status = [getStatusValue]
    setOnProgress(true);
    const resultTemp = await getTaskAnalytics(particularTaskDetails.taskId, newPerPage, offset, search, status);
    setFilteredAnalyticsData(resultTemp.data.exhibitors);
    setTotalCount(resultTemp.data.total_count);
    setOnProgress(false);
  };
  const handlePerRowsChange = async (newPerPage) => {
    setOnProgress(true);
    const resultTemp = await getTaskAnalytics(particularTaskDetails.taskId, newPerPage, offset, search, filterParams);
    setLimit(newPerPage);
    setFilteredAnalyticsData(resultTemp.data.exhibitors);
    setTotalCount(resultTemp.data.total_count);
    setOnProgress(false);
  };

  const handlePageChange = async (page) => {
    setOnProgress(true);
    const resultTemp = await getTaskAnalytics(particularTaskDetails.taskId, limit, limit * (page - 1), search, filterParams);
    setOffset(limit * (page - 1));
    setFilteredAnalyticsData(resultTemp.data.exhibitors);
    setOnProgress(false);
  };

  const setSearchFunction = async (tempVal) => {
    setOnProgress(true);
    setSearch(tempVal);
    const resultTemp = await getTaskAnalytics(particularTaskDetails.taskId, limit, offset, tempVal, filterParams);
    setFilteredAnalyticsData(resultTemp.data.exhibitors);
    setTotalCount(resultTemp.data.total_count);
    setOnProgress(false);
  };


  const getAnalytics = async (taskId) => {
    if (!taskId) return;
    setOnProgress(true);
    const res = await getTaskAnalytics(taskId, limit, offset, search, filterParams);
    setExhibitors(res.data.exhibitors);
    setAnalyticsResponse(res.data.analytics);
    setOnProgress(false);
  };
  const fetchTaskAnalytics = async () => {
    setOnProgress(true);
    try {
      const res = await getTaskAnalytics(particularTaskDetails.taskId, limit, offset, search, filterParams);
      setSelectedStatus(null);
      setExhibitors(res.data.exhibitors);
      setAnalyticsResponse(res.data.analytics);
      setOnProgress(false);
    } catch (err) {
      customToast.error(ErrMessages.INTERNAL_SERVER_ERROR);
      setOnProgress(false);
    }
  };


  useEffect(() => {
    if (particularTaskDetails.taskId) {
      getAnalytics(particularTaskDetails.taskId);
    }
  }, [particularTaskDetails.taskId, offset, search, filterParams]);


  useEffect(() => {
    const exhibitorsData = exhibitors;
    setAttendees(exhibitorsData);
    setFilteredAttendees(exhibitorsData);
    setExhibitorData(exhibitorsData);
    setFilteredAnalyticsData(exhibitorsData);
  }, [analyticsResponse, exhibitors]);


  useEffect(() => {
    if (selectedStatus) {
      setFilteredAnalyticsData(
        exhibitorData.filter((exhibitor) => exhibitor.status === selectedStatus)
      );
    } else {
      setFilteredAnalyticsData(exhibitorData);
    }
  }, [selectedStatus, exhibitorData]);

  const columns = [
    {
      name: "S.No",
      selector: "s_no",
      sortable: true,
      minWidth: "70px",
      maxWidth: "70px",
      cell: (_data, index) => index + 1,
    },
    {
      name: "Exhibitor Name",
      selector: "entity_name",
      cell: (_data) => (
        <>
          <span>{cutString(_data.entity_name, 17)}</span>
          <TippyIcon
            content={
              <span className="text-center">
                View all tasks for this exhibitor
              </span>
            }
          >
            <div>
              <Link target="_blank" rel="noopener noreferrer" className="d-flex align-items-center" style={style} to={`/e/${eventId}/exhibitor-portal/${_data.exhibitor_id}/tasks`}>
                <img
                  style={{ width: "16px", height: "16px", marginLeft: "10px" }}
                  src={priorityBasedIcons.REDIRECT}
                  alt=""
                />
              </Link>
            </div>
          </TippyIcon>
        </>
      ),
      sortable: true,
    },
    {
      name: "Last Updated At",
      selector: "updated_at",
      cell: (_data) => <span>{_data.updated_at ? getISTDateNTimeWTimeZone(_data.updated_at) : "Not updated yet"}</span>,
      sortable: true,
    },
    {
      name: "Status",
      cell: (_data) => {
        const statusClass = getStatusClassName(_data.task_status);
        return <span className={`task-tag ${statusClass}`}>{getTaskStatusText(_data.task_status)}</span>;
      },
      sortable: false,
    },
  ];


  const getTaskCountForStatus = (status) => {
    const statusUpperCase = status.toUpperCase();
    const statusCode = EXHIBITOR_TASK_STATUS[statusUpperCase];
    return analyticsResponse[statusCode] || 0;
  };

  const getFilteredTiles = (tasktype) => {
    if (tasktype?.toString() === EXHIBITOR_TASK_TYPES.INFORMATION.toString()) {
      return filterTiles.filter(tile => tile.id === EXHIBITOR_TASK_STATUS.PENDING || tile.id === EXHIBITOR_TASK_STATUS.ACCEPTED);
    }
    return filterTiles.filter(tile => tile.id !== EXHIBITOR_TASK_STATUS.ACCEPTED);
  };
  const handleClick = (tile) => {
    const statusValue = getStatusValue(tile.status);
    const filteredData = handleFilterTile(statusValue);
    setFilteredAnalyticsData(filteredData);
    setSelectedStatus(selectedStatus === statusValue ? null : statusValue);
  };


  const onRowClicked = async (row) => {
    setOpenModal(true);
    setSelectedRowData(row);
  }
  return (
    <KonfhubContainer>
      <div className="d-flex justify-content-between w-100 taskanalytics-container">
        <div className="task-details d-flex flex-column gap-3">
          <div className="d-flex align-items-center mb-2">
            <span onClick={() => history.push(`/e/${eventId}/exhibitor-portal/task-management`)} className="mr-2 back-btn">
              <img src={backbtn} alt="Back" />
            </span>
            <h3 className="task-title mb-0 mr-2">{particularTaskDetails?.title}</h3>
            <span className='cursor-pointer refresh-btn' onClick={fetchTaskAnalytics} >
              {!onProgress ? <img src={refreshBtn} alt="" /> : <div className=" ms-2 spinner-border  spinner-border-sm upload-spinner" role="status">
                <span className="visually-hidden"></span>
              </div>}
            </span>
          </div>
          <div className="task-dates d-flex gap-2">
            <div className="due-date mr-4">
              <span className="due-date-heading">Due date:</span>
              <span className="reminder-date-txt">{getISTDateNTime(particularTaskDetails?.due_date, eventTimezone,"needed")}</span>
            </div>
            <div className="reminder-date">
              <span className="reminder-date-heading">Reminder Date:</span>
              <span className="reminder-date-txt">{getISTDateNTime(particularTaskDetails?.reminder_date, eventTimezone,"needed")}</span>
            </div>
          </div>
        </div>

        <div className="d-flex task-search-container  px-0">
          <div className="w-100 pr-3">
            <SearchBar
              containerClass="search-container"
              search={search}
              setSearchFunction={setSearchFunction}
              searchPlaceholder="Search..."
            />
          </div>
          <TaskAnalyticsFilter
            analyticsData={filteredAnalyticsData}
            setFilteredAnalyticsData={setFilteredAnalyticsData}
            isRightAlign={false}
            setTotalCount={setTotalCount}
            filterDataConfig={filterDataConfig}
            setFilteredDataConfig={setFilteredDataConfig}
            displaySelectedFilters={displaySelectedFilters}
            setDisplaySelectedFilters={setDisplaySelectedFilters}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            statusDataName={statusDataName}
            setStatusDataName={setStatusDataName}
            data={data}
            taskId={particularTaskDetails.taskId}
            limit={limit}
            offset={offset}
            search={search}
            setIsRemoveFilterClicked={setIsRemoveFilterClicked}
            isRemoveFilterClicked={isRemoveFilterClicked}
          />
        </div>
      </div>
      <div className="mt-2">
        <SelectedFiltersDisplay
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          displaySelectedFilters={displaySelectedFilters}
          statusDataName={statusDataName}
          setIsRemoveFilterClicked={setIsRemoveFilterClicked}
          isRemoveFilterClicked={isRemoveFilterClicked}
        />
      </div>
      <div className="filter-tiles mt-4 mb-2">
        {getFilteredTiles(particularTaskDetails.taskType).map((tile) => {
          const taskCount = getTaskCountForStatus(tile.status);
          const tileStatus = tile?.status?.toUpperCase()
          return (
            <div
              key={tile.status}
              onClick={() => handleClick(tile)}
              className={`filter-tile ${selectedStatus === EXHIBITOR_TASK_STATUS[tileStatus] ? "active" : ""}`}
            >
              <p>{tile.name}</p>
              <span>{taskCount}</span>
            </div>
          );
        })}
      </div>

      {onProgress ? <LoadingSpinner /> : <BackendPaginatedDataTable
        rowData={filteredAnalyticsData}
        columns={columns}
        totalCount={totalCount}
        paginationServer={false}
        noDataComponent={
          <p className="mt-5 font-weight-normal mb-4 no-task-found">No Exhibitors Found</p>
        }
        onProgress={onProgress}
        pagination={true}
        handlePerRowsChange={handlePerRowsChange}
        handlePageChange={handlePageChange}
        onRowClicked={onRowClicked}
      />}
      <TaskSidebarModal data={selectedRowData} openModal={openModal} setOpenModal={setOpenModal} taskId={particularTaskDetails.taskId} particularTaskDetails={particularTaskDetails} />
      <style jsx>
        {`
          .filter-tiles {
            display: flex;
            gap: 10px;
            margin-bottom: 20px;
          }
         .task-search-container .search-container {
            width: 100% !important;
            display: flex;
            align-items: center;
            height: 36px;
          }
          .task-title{
            font-weight: 500;
            font-size: 16px;
            color: var(--primaryColor) !important;
          }
            .no-task-found{
              font-weight: 500 ;
              font-size: 16px;
              color: #6D7780;
         }
         .back-btn{
          cursor: pointer;
         }
          .due-date-heading , .reminder-date-heading {
            font-weight: 500;
            font-size: 14px;
            color:#333333;
            margin-right: 4px !important;
          }
          .due-date-txt  , .reminder-date-txt  {
            font-weight: 400;
            font-size: 14px;
            color:#333333;
            margin-left: 4px;
          }

          .filter-tile {
            padding: 10px;
            background-color: #fff;
            cursor: pointer;
            border-radius: 4px;
            border: 1px solid #c3cddf;
            padding: 4px 10px;
            flex: 1;
            margin: 10px 0px;
            border: 1px solid #c3cddf;
          }
          .filter-tile p {
            font-weight: 400;
            font-size: 14px;
            color: var(--primaryColor) !important;
          }
          .filter-tile span {
            font-weight: 500;
            font-size: 20px;
            color: var(--primaryColor) !important;
          }

          .filter-tile.active {
            background-color: white;
            border: 2px solid var(--primaryColor) !important;
          }
          .task-tag {
            padding: 5px 10px;
            border-radius: 4px;
            color: white;
          }
          .task-status-common{
            padding: 4px 10px;
            border-radius: 2px;
            font-weight: 500;
            font-size: 12px;
          }
          .status-pending {
            background-color: #f8ddcb;
            color: #fc6500;
          }

          .status-submitted {
            background-color: #ebf3ff; 
            color: #002e6e;
          }
           .upload-spinner{
                width: 15px !important;
                height: 15px !important;
                color:${dashboardColors[theme].primary} !important;
            }

          .status-approved {
            background-color: #CBFFD3;
            color: #23A738;
          }

          .status-rejected {
            background-color: #dc3545; 
            color: #fff;
          }
          .refresh-btn{
            height: 24px;
            width: 24px;
            cursor: pointer;
          }
          .status-resubmit {
            background-color: #ffdbdf; 
            color: #dc3545;
          }

          .defaultStatus {
            background-color: #7f8c8d; 
          }
          .status-accepted {
              background-color: #23a738; 
              color: #cbffd3;
            }

          .filter-tiles {
            display: flex;
            gap: 10px;
            margin-bottom: 20px;
          }

          .filter-tile {
            padding: 4px 10px;
            cursor: pointer;
            border-radius: 4px;
            border: 1px solid #C3CDDF;
          }

          @media only screen and (max-width: 600px) {
            .taskanalytics-container{
                  flex-direction:column !important;
                  gap:10px !important;
              }
            .task-dates{
               margin-top:5px;
              flex-direction:column !important;
              gap:10px !important;
            }
          }
        `}
      </style>
    </KonfhubContainer>
  );
};

export default TaskAnalytics;